"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallbackContainer = exports.Callback = void 0;
const tslib_1 = require("tslib");
/* eslint-disable require-jsdoc */
const core_1 = require("@material-ui/core");
const react_1 = tslib_1.__importStar(require("react"));
const authentication_service_1 = require("../authentication-service");
const Callback = () => (react_1.default.createElement(core_1.Container, { maxWidth: "sm" },
    react_1.default.createElement(core_1.Typography, { component: "h1", gutterBottom: true }, "Authentication complete"),
    react_1.default.createElement(core_1.Typography, { variant: "body1" }, "You will be redirected to your application.")));
exports.Callback = Callback;
const CallbackContainer = ({ callbackComponentOverride, history }) => {
    react_1.useEffect(() => {
        function signIn() {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                try {
                    // In here we are most probably going to have userManager if not the error will be catched
                    const user = yield authentication_service_1.getUserManager().signinRedirectCallback();
                    if (user.state.url) {
                        history.push(user.state.url);
                    }
                    else {
                        console.warn('no location in state');
                    }
                }
                catch (error) {
                    history.push(`/authentication/not-authenticated?message=${encodeURIComponent(error.message)}`);
                }
            });
        }
        signIn();
    }, [history]);
    return callbackComponentOverride ? react_1.default.createElement(react_1.default.Fragment, null, callbackComponentOverride) : react_1.default.createElement(exports.Callback, null);
};
exports.CallbackContainer = CallbackContainer;
//# sourceMappingURL=callback.js.map